export const PublicPath = {
	login: "/auth/*",
	restorePassword: "restorepassword/",
	register: "register/",
	newPassword: "newPassword/",
};

export const PrivatePath = {
	users: "/users",
	home: "/",
	vrTraining: "vrt/",
	vrLearning: "vrl/",
	dashboardVrl: "dashboard/",
	tableUsers: "users/",
	tableVrl: "table/",
	analyticsVrl: "analytics/",
    help: "help",
	inmersys: "inmersys",
	client: "client",
	vrlAdmin: "vrl/",
	proyectId: ":idEnterprise/",
};

export const PrincipalPath = {
	root: "/*",
	private: "/app/*",
	public: "/auth/*",
};
